import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Mail, Globe, Copy } from 'lucide-react';
import { showSuccess } from '../../utils/Alert';
import './ShareModal.css';

const ShareModal = ({ isOpen, onClose, shareUrl, title }) => {
    const handleCopyLink = () => {
        navigator.clipboard.writeText(shareUrl);
        showSuccess('Link Copied!', 'Link copied to clipboard.');
    };

    return (
        <AnimatePresence>
            {isOpen && (
                <div className="share-modal-overlay" onClick={onClose}>
                    <motion.div
                        initial={{ scale: 0.95, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0.95, opacity: 0 }}
                        className="share-modal-content"
                        onClick={e => e.stopPropagation()}
                    >
                        <div className="sm-header">
                            <h3>Share this {title}</h3>
                            <button className="close-sm" onClick={onClose}><X size={20} /></button>
                        </div>
                        <div className="sm-body">
                            <button className="share-opt" onClick={() => window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(title + " " + shareUrl)}`, '_blank')}>
                                <Globe size={50} color="#25D366" />
                                <span>WhatsApp</span>
                            </button>
                            <button className="share-opt" onClick={() => window.location.href = `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(shareUrl)}`}>
                                <Mail size={50} color="#3b82f6" />
                                <span>Email</span>
                            </button>
                            <button className="share-opt" onClick={handleCopyLink}>
                                <Copy size={50} color="#64748b" />
                                <span>Copy Link</span>
                            </button>
                        </div>
                        <div className="sm-footer">
                            <input type="text" readOnly value={shareUrl} />
                            <button onClick={handleCopyLink}>Copy</button>
                        </div>
                    </motion.div>
                </div>
            )}
        </AnimatePresence>
    );
};

export default ShareModal;
